{
  "app": {
    "cannotStart": "CosmosAI Studio ne peut pas démarrer"
  },
  "auth": {
    "signInFailed": "Échec de la connexion",
    "signInAgain": "Se reconnecter",
    "signedOut": "Déconnecté",
    "signedOutText": "Vous avez quitté CosmosAI Studio.",
    "signOut": "Se déconnecter"
  },
  "health": {
    "nav": "État de la plateforme",
    "title": "État de la plateforme",
    "description": "Le backend web, sa base de données et l'API cosmos.",
    "checking": "Vérification…",
    "noAnswer": "Le backend web n'a pas répondu. `pnpm dev` est-il lancé ?",
    "webApi": "Backend web {{version}}",
    "database": "Base de données cosmos_web",
    "cosmos": "API cosmos",
    "cosmosVersion": "API cosmos {{version}}",
    "status": {
      "ok": "ok",
      "down": "indisponible"
    }
  },
  "ui": {
    "close": "Fermer",
    "copy": "Copier",
    "copied": "Copié",
    "error": {
      "title": "Une erreur est survenue",
      "trace": "ID de trace",
      "copyTrace": "Copier l'ID de trace"
    },
    "status": {
      "draft": "Brouillon",
      "active": "Actif",
      "archived": "Archivé",
      "deployed": "Déployé",
      "deploying": "Déploiement en cours",
      "failed": "Échec"
    },
    "copyCommand": "Copier la commande",
    "outcome": {
      "changes": "Changements",
      "problems": "Problèmes",
      "error": "Erreur",
      "warning": "Avertissement",
      "nothing": "Rien n’a changé.",
      "change": {
        "created": "créée",
        "updated": "mise à jour",
        "unchanged": "inchangée",
        "deleted": "supprimée"
      }
    },
    "command": {
      "typeName": "Saisissez {{name}} pour confirmer",
      "refused": "La plateforme a refusé",
      "cancel": "Annuler",
      "close": "Terminé",
      "running": "En cours…"
    }
  },
  "shell": {
    "skipToContent": "Aller au contenu",
    "mainNavigation": "Navigation principale",
    "openNavigation": "Ouvrir la navigation",
    "brandHome": "Accueil de CosmosAI Studio",
    "brandSub": "Studio",
    "search": "Rechercher ou aller à…",
    "searchLabel": "Rechercher ou aller à ({{keys}})",
    "shortcutsHelp": "Aide et raccourcis clavier",
    "accountMenu": "Menu du compte, {{name}}",
    "demoBanner": {
      "title": "Données de démonstration.",
      "text": "Ce Studio s'adresse à une maquette de l'API cosmos : les données sont fictives et repartent de zéro à son redémarrage."
    },
    "prodBanner": {
      "title": "La production est en lecture seule.",
      "text": "Les changements n’arrivent en production que par promotion."
    },
    "status": {
      "checking": "Vérification de la plateforme…",
      "ok": "Tous les systèmes fonctionnent",
      "degraded": "Certains services sont indisponibles",
      "unreachable": "Plateforme injoignable"
    }
  },
  "nav": {
    "groups": {
      "home": "Accueil",
      "work": "Travail",
      "build": "Construire",
      "resources": "Ressources",
      "deliver": "Livrer",
      "monitor": "Superviser",
      "admin": "Administration",
      "account": "Compte"
    }
  },
  "palette": {
    "title": "Recherche et commandes",
    "description": "Tapez pour filtrer les pages et les actions, puis appuyez sur Entrée.",
    "placeholder": "Rechercher des pages et des actions",
    "empty": "Aucun résultat pour « {{query}} ».",
    "move": "pour se déplacer",
    "open": "pour ouvrir",
    "close": "pour fermer",
    "groups": {
      "pages": "Pages",
      "actions": "Actions",
      "specs": "Specs"
    }
  },
  "commands": {
    "theme": "Changer de thème",
    "language": "Changer de langue",
    "shortcuts": "Afficher les raccourcis clavier",
    "uiGallery": "Ouvrir la galerie d’interface (développement)"
  },
  "shortcuts": {
    "title": "Raccourcis clavier",
    "description": "Chaque écran fonctionne aussi au clavier seul.",
    "palette": "Rechercher ou aller à n’importe quoi",
    "help": "Afficher les raccourcis clavier",
    "escape": "Fermer un menu, un panneau ou une boîte de dialogue"
  },
  "theme": {
    "toDark": "Passer au thème sombre",
    "toLight": "Passer au thème clair"
  },
  "user": {
    "organization_one": "Organisation",
    "organization_other": "Organisations",
    "language": "Langue",
    "languages": {
      "en": "English",
      "fr": "Français"
    },
    "securitySettings": "Paramètres de sécurité"
  },
  "account": {
    "loading": "Chargement…",
    "profile": {
      "nav": "Profil",
      "title": "Profil",
      "description": "Des informations qui aident vos collègues à vous joindre. Vous seul pouvez les voir et les modifier.",
      "identity": "Identité de connexion",
      "name": "Nom",
      "email": "E-mail",
      "managed": "Géré par votre fournisseur de connexion.",
      "details": "Informations",
      "jobTitle": "Fonction",
      "phone": "Téléphone",
      "phoneHint": "Format international, par exemple +33 1 23 45 67 89.",
      "address": "Adresse postale",
      "addressHint": "Laissez tous les champs vides pour ne garder aucune adresse.",
      "line1": "Adresse, ligne 1",
      "line2": "Adresse, ligne 2",
      "postalCode": "Code postal",
      "city": "Ville",
      "country": "Code pays",
      "countryHint": "Deux lettres, par exemple FR ou DE.",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "saved": "Profil enregistré.",
      "invalidSummary": "Certains champs sont à corriger.",
      "invalid": {
        "jobTitle": "120 caractères au plus.",
        "phone": "Saisissez de 6 à 25 chiffres, espaces, points, tirets ou parenthèses, avec un + initial facultatif.",
        "address": {
          "line1": "Saisissez la première ligne de l'adresse (200 caractères au plus).",
          "line2": "200 caractères au plus.",
          "postalCode": "Saisissez un code postal (20 caractères au plus).",
          "city": "Saisissez une ville (100 caractères au plus).",
          "country": "Saisissez un code pays de deux lettres, par exemple FR."
        }
      },
      "changedTitle": "Ce profil a été modifié dans un autre onglet ou sur un autre appareil.",
      "changedText": "Vos modifications ne sont pas enregistrées et restent dans le formulaire. Rechargez pour voir la dernière version, puis appliquez à nouveau vos modifications.",
      "reload": "Recharger le profil",
      "data": "Vos données",
      "dataText": "Téléchargez ou effacez ce que CosmosAI Studio garde sur vous : ce profil et vos préférences. Votre compte de connexion et votre travail sur la plateforme ne sont pas concernés.",
      "export": "Télécharger mes données",
      "exporting": "Préparation…",
      "erase": "Effacer mes données",
      "eraseTitle": "Effacer vos données du Studio ?",
      "eraseText": "Votre profil et vos préférences sont supprimés définitivement, puis vous êtes déconnecté. Votre compte de connexion et votre travail sur la plateforme restent inchangés.",
      "eraseConfirm": "Saisissez {{value}} pour confirmer",
      "eraseAction": "Effacer et se déconnecter",
      "erasing": "Effacement…",
      "cancel": "Annuler"
    },
    "preferences": {
      "nav": "Préférences",
      "title": "Préférences",
      "description": "L'apparence de CosmosAI Studio pour vous, sur chaque appareil où vous vous connectez. Les changements s'appliquent immédiatement.",
      "theme": "Thème",
      "themes": {
        "system": "Comme le système",
        "light": "Clair",
        "dark": "Sombre"
      },
      "language": "Langue",
      "density": "Densité",
      "densities": {
        "comfortable": "Confortable",
        "compact": "Compacte"
      },
      "notSaved": "Vos préférences n'ont pas pu être enregistrées ; elles ne valent que pour cette page."
    }
  },
  "context": {
    "change": "Changer d’espace de travail ou de projet (actuel : {{context}})",
    "none": "aucun",
    "choose": "Choisir un espace de travail",
    "workspace": "Espace de travail",
    "project": "Projet",
    "allProjects": "Tous les projets",
    "team": "Équipe {{team}}",
    "loading": "Chargement…",
    "failed": "La liste n’a pas pu être chargée.",
    "environment": "Environnement",
    "unreachable": "L’API cosmos n’a pas répondu",
    "noWorkspace": "Aucun espace de travail",
    "noWorkspaceText": "Un espace de travail regroupe les équipes, projets, environnements et specs d’un groupe. Créez-en un avec la CLI cosmos, puis rechargez cette page."
  },
  "kinds": {
    "agent": {
      "one": "Agent",
      "other": "Agents"
    },
    "prompt": {
      "one": "Prompt",
      "other": "Prompts"
    },
    "orchestration": {
      "one": "Orchestration",
      "other": "Orchestrations"
    },
    "knowledge-base": {
      "one": "Base de connaissances",
      "other": "Bases de connaissances"
    },
    "retriever": {
      "one": "Retriever",
      "other": "Retrievers"
    },
    "skill": {
      "one": "Compétence",
      "other": "Compétences"
    },
    "eval-suite": {
      "one": "Suite d’évaluation",
      "other": "Suites d’évaluation"
    },
    "dataset": {
      "one": "Jeu de données",
      "other": "Jeux de données"
    },
    "model": {
      "one": "Modèle",
      "other": "Modèles"
    },
    "mcp-server": {
      "one": "Serveur MCP",
      "other": "Serveurs MCP"
    },
    "connection": {
      "one": "Connexion",
      "other": "Connexions"
    },
    "schedule": {
      "one": "Planification",
      "other": "Planifications"
    },
    "workspace": {
      "one": "Espace de travail",
      "other": "Espaces de travail"
    },
    "team": {
      "one": "Équipe",
      "other": "Équipes"
    },
    "project": {
      "one": "Projet",
      "other": "Projets"
    },
    "environment": {
      "one": "Environnement",
      "other": "Environnements"
    },
    "unknown": {
      "one": "Spec",
      "other": "Specs"
    }
  },
  "home": {
    "nav": "Accueil",
    "description": "Espace de travail {{workspace}} : ses specs, les versions de chaque environnement et les derniers changements.",
    "loading": "Chargement…",
    "empty": "Aucune spec dans cet espace de travail",
    "emptyText": "Appliquez des fichiers YAML avec la CLI cosmos ; leurs premières versions arrivent en brouillon dans l’environnement indiqué.",
    "noChanges": "Rien n’a encore bougé dans les environnements.",
    "recent": "Changements récents",
    "recentText": "Les 20 derniers événements, tous environnements confondus.",
    "tiles": {
      "specs": "Specs",
      "total": "Objets, selon l’état de leur dernière version",
      "kinds": "Specs par type",
      "deployed": "Versions déployées"
    },
    "tiers": {
      "development": "développement",
      "staging": "pré-production",
      "production": "production"
    },
    "columns": {
      "spec": "Spec",
      "action": "Action",
      "environment": "Environnement",
      "versions": "Versions",
      "by": "Par",
      "at": "Quand"
    },
    "actions": {
      "apply": "Appliquée",
      "promote": "Promue",
      "rollback": "Restaurée",
      "discard": "Abandonnée",
      "browse": "Parcourir les specs",
      "scopes": "Équipes et projets",
      "applyYaml": "Appliquer du YAML"
    },
    "cli": {
      "title": "Utiliser la CLI",
      "text": "Pointez la CLI cosmos sur cet espace de travail pour le terminal courant.",
      "copyPowerShell": "Copier pour PowerShell",
      "copyShell": "Copier pour bash ou zsh"
    }
  },
  "specs": {
    "title": "Specs",
    "description": "Toutes les specs versionnées de l’espace de travail, avec la version de chaque environnement.",
    "loading": "Chargement des specs…",
    "favorite": "Favori : {{name}}",
    "filters": {
      "search": "Rechercher par nom ou référence",
      "kind": "Type",
      "allKinds": "Tous les types",
      "project": "Projet",
      "allProjects": "Tous les projets",
      "state": "État",
      "allStates": "Tous les états"
    },
    "columns": {
      "favorite": "Favori",
      "kind": "Type",
      "name": "Nom",
      "project": "Projet",
      "latest": "Dernière version",
      "createdBy": "Créée par",
      "updated": "Mise à jour"
    },
    "noMatch": "Aucune spec ne correspond à ces filtres",
    "noMatchText": "Modifiez la recherche ou effacez les filtres.",
    "clearFilters": "Effacer les filtres",
    "noKind": "{{kind}} : aucune pour l’instant",
    "noKindText": "Appliquez un fichier YAML de ce type avec la CLI cosmos ; sa première version arrive en brouillon."
  },
  "spec": {
    "loading": "Chargement de la spec…",
    "breadcrumb": "Fil d’Ariane",
    "unknownKind": "« {{kind}} » n’est pas un type du registre.",
    "runsNowhere": "Ne tourne dans aucun environnement",
    "tabsLabel": "Sections de la spec",
    "tabs": {
      "overview": "Vue d’ensemble",
      "versions": "Versions",
      "yaml": "YAML",
      "diff": "Différences"
    },
    "fields": {
      "kind": "Type",
      "reference": "Référence",
      "project": "Projet",
      "versions": "Versions",
      "latestPublished": "Dernière publiée",
      "runningIn": "Tourne dans",
      "digest": "Empreinte de la dernière version",
      "created": "Dernière version créée"
    },
    "copyDigest": "Copier l’empreinte",
    "cli": "La lire avec la CLI",
    "columns": {
      "version": "Version",
      "state": "État",
      "digest": "Empreinte",
      "created": "Créée",
      "published": "Publiée",
      "environments": "Environnements",
      "actions": "Actions"
    },
    "viewYaml": "YAML de v{{version}}",
    "compareWith": "Comparer v{{version}}",
    "version": "Version",
    "yamlLabel": "YAML de {{name}} v{{version}}",
    "copyYaml": "Copier le YAML",
    "download": "Télécharger",
    "diff": {
      "from": "De",
      "to": "À",
      "changed": "Modifié : {{fields}}.",
      "same": "Les documents sont identiques, hormis la version.",
      "single": "Une seule version",
      "singleText": "Appliquez une nouvelle version de cette spec pour la comparer à celle-ci.",
      "label": "Changements de {{name}} de v{{from}} à v{{to}}"
    },
    "actions": {
      "publish": {
        "button": "Publier v{{version}}",
        "title": "Publier {{ref}} ?",
        "text": "Une version publiée ne change plus jamais et peut être promue vers les environnements suivants.",
        "confirm": "Publier v{{version}}"
      },
      "deprecate": {
        "button": "Déprécier v{{version}}",
        "title": "Déprécier {{ref}} ?",
        "text": "Elle continue de tourner là où elle tourne, mais n’est plus jamais promue.",
        "confirm": "Déprécier v{{version}}"
      },
      "discard": {
        "button": "Abandonner v{{version}}",
        "title": "Abandonner {{ref}} ?",
        "text": "Le brouillon est supprimé définitivement, avec le pointeur de développement vers lui. La plateforme refuse si une spec déployée l’utilise.",
        "confirm": "Abandonner v{{version}}"
      }
    }
  },
  "scopes": {
    "nav": "Équipes et projets",
    "title": "Équipes et projets",
    "description": "Les équipes possèdent les projets ; les specs de niveau projet vivent dans un projet. Les espaces de travail se créent avec la CLI.",
    "loading": "Chargement des équipes et projets…",
    "refused": "La plateforme a refusé",
    "close": "Terminé",
    "columns": {
      "name": "Nom",
      "displayName": "Nom affiché",
      "projects": "Projets",
      "team": "Équipe",
      "version": "Version"
    },
    "fields": {
      "name": "Nom",
      "nameHint": "Lettres minuscules, chiffres et tirets ; il ne pourra plus changer.",
      "nameInvalid": "Utilisez des lettres minuscules, chiffres et tirets, 63 caractères au plus, en commençant et finissant par une lettre ou un chiffre.",
      "displayName": "Nom affiché (facultatif)",
      "team": "Équipe propriétaire",
      "teamRequired": "Choisissez l’équipe propriétaire du projet."
    },
    "team": {
      "title": "Équipes",
      "new": "Nouvelle équipe",
      "text": "Une équipe possède des projets et les personnes qui y travaillent.",
      "create": "Créer l’équipe",
      "none": "Aucune équipe"
    },
    "project": {
      "title": "Projets",
      "new": "Nouveau projet",
      "text": "Un projet regroupe les agents, prompts, bases de connaissances et autres specs de niveau projet.",
      "create": "Créer le projet",
      "none": "Aucun projet",
      "specs": "Specs du projet {{project}}"
    }
  },
  "environments": {
    "nav": "Environnements et promotion",
    "title": "Environnements et promotion",
    "description": "Chaque objet passe du développement à la pré-production puis à la production par promotion. La production ne change jamais autrement.",
    "board": "Versions par environnement",
    "loading": "Chargement…",
    "empty": "Rien n’est encore déployé",
    "emptyText": "Appliquez du YAML à un environnement de développement ; ses versions apparaissent ici et montent par promotion.",
    "noMatch": "Aucun objet ne correspond à ces filtres",
    "noMatchText": "Changez la recherche, le type ou le projet.",
    "columns": {
      "object": "Objet"
    },
    "filters": {
      "search": "Rechercher par nom ou référence",
      "kind": "Type",
      "project": "Projet",
      "applied_one": "Seulement l’objet appliqué ({{count}})",
      "applied_other": "Seulement les {{count}} objets appliqués"
    },
    "cell": {
      "none": "Absent de {{env}}",
      "sameAs": "Identique à {{env}}",
      "publishFirst": "Publiez-la pour la promouvoir vers {{env}}",
      "publishFirstFor": "Publier {{ref}} pour le promouvoir vers {{env}}"
    },
    "promote": {
      "button": "Promouvoir vers {{env}}",
      "buttonFor": "Promouvoir {{ref}} vers {{env}}",
      "title": "Promouvoir {{ref}} vers {{env}} ?",
      "text": "{{env}} exécutera cette version. Les objets qu’elle utilise doivent déjà tourner dans {{env}}, ou être promus d’abord.",
      "confirm": "Promouvoir vers {{env}}",
      "reference": "Référence",
      "from": "Depuis",
      "to": "Vers",
      "replaces": "Remplace",
      "nothing": "Rien : {{env}} ne l’exécute pas encore"
    },
    "promoteMany": {
      "button": "Promouvoir {{count}}",
      "open": "Promouvoir {{count}} de {{from}} vers {{env}}",
      "title": "Promouvoir de {{from}} vers {{env}} ?",
      "text": "{{env}} exécutera les versions cochées, en une seule promotion : des objets promus ensemble peuvent s’utiliser entre eux.",
      "list": "Versions à promouvoir",
      "new": "Nouveau dans {{env}}",
      "replaces": "Remplace v{{version}}",
      "confirm": "Promouvoir {{count}} vers {{env}}"
    },
    "rollback": {
      "button": "Restaurer",
      "buttonFor": "Restaurer une version de {{ref}} dans {{env}}",
      "title": "Restaurer une version de {{ref}} dans {{env}} ?",
      "text": "{{env}} exécute la v{{version}} aujourd’hui. Il revient à la version choisie ; la v{{version}} reste dans l’historique.",
      "confirm": "Restaurer la v{{version}}",
      "current": "En cours",
      "choose": "Version à exécuter de nouveau"
    },
    "history": {
      "button": "Historique",
      "open": "Historique de {{env}}",
      "text": "Ce qui a changé ici, du plus récent au plus ancien. Chaque événement ouvre la comparaison des deux versions.",
      "events": "Événements",
      "to": "vers",
      "empty": "Rien n’a encore changé dans {{env}}.",
      "diff": "Comparer v{{from}} → v{{to}}",
      "version": "Ouvrir la v{{version}}"
    }
  },
  "apply": {
    "nav": "Appliquer",
    "command": "Appliquer du YAML",
    "title": "Appliquer du YAML",
    "description": "Collez ou téléversez des fichiers de specs, lisez le plan, puis appliquez-les à un environnement de développement. Rien n’est conservé quand vous quittez la page.",
    "target": {
      "title": "Où",
      "project": "Projet",
      "noProject": "Aucun projet (types de niveau espace de travail seulement)",
      "environment": "Environnement",
      "production": "La pré-production et la production ne sont pas proposées : les versions y arrivent seulement par promotion.",
      "cliNote": "Le CLI lit ces fichiers sur votre disque."
    },
    "files": {
      "title": "Fichiers",
      "new": "Nouveau fichier",
      "upload": "Téléverser des fichiers",
      "drop": "Déposez des fichiers YAML ici, téléversez-les ou commencez un nouveau fichier.",
      "unnamed": "(pas encore de chemin)",
      "remove": "Retirer {{path}}"
    },
    "editor": {
      "title": "Éditeur",
      "path": "Chemin",
      "label": "YAML de {{path}}",
      "none": "Aucun fichier sélectionné",
      "noneText": "Ajoutez un fichier à gauche, puis sélectionnez-le pour le modifier."
    },
    "limits": {
      "title": "Ce qui bloque le plan",
      "files": "Un lot contient au plus {{max}} fichiers.",
      "noPath": "Chaque fichier doit avoir un chemin.",
      "path": "{{path}} dépasse {{max}} caractères.",
      "twice": "Deux fichiers ont le même chemin {{path}}.",
      "size": "{{path}} dépasse {{max}}."
    },
    "plan": {
      "title": "Plan",
      "text": "La plateforme vérifie chaque fichier et liste ce que l’application changerait. « Appliquer » n’est possible que pour les entrées d’un plan sans erreur.",
      "button": "Planifier",
      "none": "Planifiez les fichiers pour voir ce qui changerait.",
      "stale": "Les fichiers, le projet ou l’environnement ont changé depuis le dernier plan : planifiez de nouveau.",
      "blocked": "Des erreurs bloquent l’application. Corrigez-les, puis planifiez de nouveau.",
      "changes": "Ce que l’application changerait",
      "problems": "Problèmes",
      "batch": "Le lot"
    },
    "apply": {
      "button": "Appliquer à {{env}}",
      "done": "Appliqué à {{env}}.",
      "board": "Ouvrir dans le tableau"
    },
    "leave": {
      "title": "Quitter sans appliquer ?",
      "text": "Les fichiers de cette page ne sont pas conservés : les brouillons appartiendront à la plateforme, plus tard.",
      "stay": "Rester",
      "go": "Quitter"
    }
  },
  "labs": {
    "stream": {
      "title": "Diagnostic de streaming",
      "description": "Des ticks du web API en Server-Sent Events : premier événement, intervalles, battements et reprise après une coupure.",
      "seconds": "Secondes",
      "start": "Démarrer",
      "stop": "Arrêter",
      "disconnect": "Forcer une déconnexion",
      "statusLabel": "État",
      "firstEvent": "Premier événement",
      "events": "Événements",
      "heartbeats": "Battements",
      "reconnects": "Reconnexions",
      "gaps": "Trous de plus de 1,5 s",
      "intervals": "Intervalles (min – max)",
      "lastEventId": "Dernier id d’événement",
      "arrivals": "Dernières arrivées (id · intervalle)",
      "ms": "{{value}} ms",
      "notAvailable": "Cette page n’existe pas",
      "status": {
        "idle": "au repos",
        "connecting": "connexion",
        "streaming": "en cours",
        "reconnecting": "reconnexion",
        "done": "terminé",
        "failed": "échec"
      }
    }
  },
  "files": {
    "nav": "Fichiers",
    "title": "Fichiers",
    "description": "Les fichiers de votre organisation, conservés sur la préversion uniquement (preuve de concept).",
    "zone": "Fichiers de votre organisation",
    "loading": "Chargement des fichiers…",
    "retry": "Réessayer",
    "empty": {
      "title": "Aucun fichier pour l'instant",
      "text": "Déposez des fichiers ici ou utilisez Téléverser des fichiers. PDF, Office, images, texte ; jusqu'à {{size}}."
    },
    "columns": {
      "name": "Nom",
      "size": "Taille",
      "uploaded": "Téléversé le",
      "actions": "Actions",
      "type": "Type"
    },
    "download": "Télécharger {{name}}",
    "downloadFailed": "Impossible de télécharger {{name}}",
    "upload": {
      "button": "Téléverser des fichiers",
      "list": "Téléversements en cours",
      "progress": "Téléversement de {{name}}",
      "percent": "{{percent}} %",
      "cancel": "Annuler",
      "cancelNamed": "Annuler le téléversement de {{name}}",
      "dismiss": "Fermer",
      "dismissNamed": "Fermer {{name}}",
      "done": "{{name}} téléversé.",
      "typeRefused": "Ce type de fichier n'est pas accepté : PDF, Office, images et texte uniquement.",
      "tooLarge": "Plus de {{size}}, la limite.",
      "refused": "Le stockage a refusé le téléversement (HTTP {{status}}).",
      "unreachable": "Le stockage est injoignable.",
      "typeMismatch": "Le remplacement doit avoir le même type que le fichier."
    },
    "delete": {
      "named": "Supprimer {{name}}",
      "title": "Supprimer {{name}} ?",
      "text": "Plus personne dans votre organisation n'y aura accès.",
      "cancel": "Annuler",
      "confirm": "Supprimer",
      "done": "{{name}} supprimé."
    },
    "crumbs": {
      "label": "Chemin du dossier",
      "root": "Fichiers"
    },
    "search": {
      "label": "Rechercher dans ce dossier"
    },
    "select": {
      "one": "Sélectionner {{name}}",
      "all": "Tout sélectionner",
      "count_one": "{{count}} sélectionné",
      "count_other": "{{count}} sélectionnés"
    },
    "folderRow": {
      "empty": "Ce dossier est vide.",
      "noMatch": "Rien ne correspond à « {{query}} » dans ce dossier."
    },
    "actions": {
      "menu": "Actions pour {{name}}",
      "preview": "Aperçu",
      "details": "Détails",
      "download": "Télécharger",
      "rename": "Renommer",
      "move": "Déplacer vers",
      "replace": "Remplacer",
      "delete": "Supprimer",
      "deleteFolder": "Supprimer le dossier"
    },
    "newFolder": {
      "button": "Nouveau dossier",
      "title": "Nouveau dossier",
      "text": "Dans {{folder}}.",
      "label": "Nom du dossier",
      "hint": "Jusqu'à 60 caractères, sans / ni \\.",
      "invalid": "Utilisez 1 à 60 caractères, sans / ni \\ ; un dossier ne porte pas le nom d'un identifiant de fichier.",
      "tooDeep": "Les dossiers ont au plus cinq niveaux.",
      "confirm": "Créer",
      "done": "Dossier {{name}} créé."
    },
    "rename": {
      "title": "Renommer {{name}}",
      "text": "Le fichier garde son dossier et son type.",
      "label": "Nouveau nom",
      "hint": "Gardez l'extension {{extension}}.",
      "invalid": "Saisissez un nom avec au moins une lettre ou un chiffre.",
      "typeMismatch": "Gardez l'extension : un fichier garde son type.",
      "confirm": "Renommer",
      "done": "Renommé en {{name}}."
    },
    "move": {
      "title": "Déplacer {{name}}",
      "text": "Le fichier garde son nom.",
      "label": "Dossier",
      "confirm": "Déplacer",
      "done": "{{name}} déplacé vers {{folder}}."
    },
    "replace": {
      "input": "Fichier de remplacement"
    },
    "deleteMany": {
      "button": "Supprimer la sélection ({{count}})",
      "title_one": "Supprimer {{count}} fichier ?",
      "title_other": "Supprimer {{count}} fichiers ?",
      "text": "Plus personne dans votre organisation n'y aura accès.",
      "tooMany": "Sélectionnez au plus 50 fichiers.",
      "more": "et {{count}} de plus",
      "confirm": "Supprimer",
      "done_one": "{{count}} fichier supprimé.",
      "done_other": "{{count}} fichiers supprimés.",
      "failed": "Non supprimés :"
    },
    "deleteFolder": {
      "title": "Supprimer le dossier {{name}} ?",
      "text": "Tout son contenu est supprimé aussi : fichiers et dossiers. Plus personne dans votre organisation n'y aura accès.",
      "confirm": "Supprimer le dossier",
      "done": "Dossier {{name}} supprimé."
    },
    "details": {
      "folder": "Dossier",
      "size": "Taille",
      "type": "Type",
      "uploaded": "Téléversé le",
      "preview": "Aperçu",
      "previewOf": "Aperçu de {{name}}",
      "loading": "Chargement de l'aperçu…",
      "none": "Pas d'aperçu pour ce type : téléchargez-le.",
      "truncated": "Seuls les 200 premiers Ko sont affichés. Téléchargez le fichier pour la suite.",
      "failed": "L'aperçu n'a pas pu être chargé"
    }
  },
  "admin": {
    "users": {
      "nav": "Utilisateurs",
      "title": "Utilisateurs",
      "description": "Les personnes de votre organisation et leur type de compte",
      "invite": "Inviter des personnes",
      "loading": "Chargement des comptes…",
      "retry": "Réessayer",
      "you": "vous",
      "empty": {
        "title": "Aucun compte pour l'instant",
        "text": "Invitez les personnes de votre organisation."
      },
      "columns": {
        "person": "Personne",
        "type": "Type",
        "status": "Statut",
        "created": "Créé",
        "actions": "Actions"
      },
      "status": {
        "invited": "Invité",
        "active": "Actif",
        "disabled": "Désactivé"
      },
      "actions": {
        "editName": "Modifier le nom",
        "menu": "Actions pour {{email}}",
        "changeType": "Changer le type",
        "disable": "Désactiver",
        "enable": "Réactiver",
        "resend": "Renvoyer l'invitation",
        "remove": "Retirer"
      },
      "resent": "Invitation renvoyée à {{email}}.",
      "resendFailed": "L'invitation n'a pas pu être renvoyée",
      "search": "Rechercher des personnes",
      "allTypes": "Tous les types",
      "allStatuses": "Tous les statuts",
      "count": "{{shown}} personnes sur {{total}}",
      "page": "{{page}} / {{pages}}",
      "previousPage": "Page précédente",
      "nextPage": "Page suivante",
      "noMatch": {
        "title": "Personne ne correspond",
        "text": "Modifiez la recherche ou les filtres."
      }
    },
    "invite": {
      "title": "Inviter des personnes",
      "text": "Elles rejoignent votre organisation avec le type de compte choisi.",
      "emails": "Adresses e-mail",
      "placeholder": "une par ligne",
      "hint": "Chaque personne reçoit un e-mail pour vérifier son adresse et choisir un mot de passe ; le lien est valable 24 heures.",
      "type": "Type de compte",
      "invalid": "Adresse e-mail non valide : {{lines}}",
      "tooMany": "Au plus 20 adresses à la fois.",
      "duplicate": "Chaque adresse une seule fois.",
      "empty": "Saisissez au moins une adresse.",
      "cancel": "Annuler",
      "send": "Envoyer les invitations",
      "done": "Terminé",
      "results": "Invitations",
      "outcome": {
        "invited": "Invitée",
        "exists": "A déjà un compte ailleurs",
        "failed": "Échec, réessayez"
      }
    },
    "changeType": {
      "title": "Changer le type de {{email}}",
      "text": "La personne est déconnectée et reçoit le nouveau type à sa prochaine connexion.",
      "type": "Type de compte",
      "confirm": "Changer le type",
      "done": "{{email}} est maintenant {{type}}."
    },
    "disable": {
      "title": "Désactiver {{email}} ?",
      "text": "La personne est déconnectée et ne peut plus se connecter tant que le compte n'est pas réactivé.",
      "confirm": "Désactiver",
      "done": "{{email}} désactivé."
    },
    "enable": {
      "title": "Réactiver {{email}} ?",
      "text": "La personne peut de nouveau se connecter, avec le même type de compte.",
      "confirm": "Réactiver",
      "done": "{{email}} réactivé."
    },
    "remove": {
      "title": "Retirer {{email}} ?",
      "text": "Le compte est désactivé et quitte l'organisation ; les données de la plateforme restent.",
      "confirm": "Retirer",
      "done": "{{email}} retiré."
    },
    "types": {
      "tenant-admin": "Super administrateur",
      "admin": "Administrateur",
      "user": "Utilisateur"
    },
    "problems": {
      "adminNotConfigured": "L'administration des comptes n'est pas configurée",
      "accountTypeNotAllowed": "Votre type de compte ne le permet pas",
      "organizationAmbiguous": "Votre compte doit appartenir à une seule organisation",
      "ownAccount": "Vous ne pouvez pas modifier votre propre compte ici",
      "lastSuperAdmin": "L'organisation a besoin d'un super administrateur",
      "notInvited": "Ce compte n'attend pas d'invitation",
      "identityProviderUnavailable": "Le fournisseur d'identité n'a pas répondu",
      "organizationNotFound": "Votre organisation est introuvable"
    },
    "editName": {
      "title": "Modifier le nom de {{email}}",
      "text": "La personne reste connectée ; le nouveau nom apparaît à sa prochaine connexion.",
      "firstName": "Prénom",
      "lastName": "Nom",
      "confirm": "Enregistrer",
      "done": "Nom de {{email}} enregistré."
    },
    "organization": {
      "nav": "Organisation",
      "title": "Organisation",
      "description": "Votre organisation telle que Keycloak la connaît ; seul son nom se modifie ici.",
      "loading": "Chargement de l'organisation…",
      "name": "Nom",
      "alias": "Alias",
      "domains": "Domaines",
      "counts": "Membres",
      "count": {
        "tenant-admin_one": "{{count}} super administrateur",
        "tenant-admin_other": "{{count}} super administrateurs",
        "admin_one": "{{count}} administrateur",
        "admin_other": "{{count}} administrateurs",
        "user_one": "{{count}} utilisateur",
        "user_other": "{{count}} utilisateurs",
        "invited_one": "{{count}} invité",
        "invited_other": "{{count}} invités",
        "disabled_one": "{{count}} désactivé",
        "disabled_other": "{{count}} désactivés"
      },
      "rename": {
        "open": "Renommer",
        "title": "Renommer l'organisation",
        "text": "L'alias reste : la connexion et les fichiers continuent de l'utiliser.",
        "confirm": "Renommer",
        "done": "L'organisation s'appelle maintenant {{name}}."
      }
    }
  },
  "knowledge": {
    "tabs": {
      "documents": "Documents",
      "generations": "Générations"
    },
    "loading": "Chargement de la base de connaissances…",
    "retryLoad": "Réessayer",
    "upload": {
      "button": "Téléverser des documents",
      "drop": "Déposer des documents ici",
      "hint": "Déposez des fichiers PDF, Word, texte, Markdown, HTML ou des images ; chacun est ingéré dans les générations de cette base. Statut affiché pour {{environment}}.",
      "list": "Téléversements",
      "progress": "Téléversement de {{name}}",
      "cancel": "Annuler",
      "cancelNamed": "Annuler le téléversement de {{name}}",
      "dismiss": "Masquer",
      "dismissNamed": "Masquer {{name}}",
      "queued": "Téléversé, ingestion en file",
      "unchanged": "Déjà dans cette base"
    },
    "empty": {
      "title": "Aucun document",
      "text": "Téléversez des documents pour construire l'index de cette base."
    },
    "count_one": "{{count}} document",
    "count_other": "{{count}} documents",
    "columns": {
      "name": "Nom",
      "type": "Type",
      "size": "Taille",
      "added": "Ajouté",
      "status": "Statut dans {{environment}}"
    },
    "status": {
      "queued": "En file",
      "running": "En cours",
      "ready": "Prêt",
      "failed": "Échec",
      "deleting": "Suppression",
      "absent": "Absent de cet environnement"
    },
    "retried_one": "{{count}} ingestion relancée",
    "retried_other": "{{count}} ingestions relancées",
    "sheet": {
      "gone": "Document supprimé",
      "description": "Le document et son ingestion dans chaque génération.",
      "copySha": "Copier le SHA-256",
      "ingestions": "Ingestions",
      "servedNowhere": "servie nulle part",
      "attempts": "Tentatives",
      "pages": "Pages",
      "chunks": "Fragments",
      "tokens": "Jetons",
      "cost": "Coût",
      "error": "Erreur",
      "retry": "Réessayer",
      "delete": "Supprimer le document",
      "deleteTitle": "Supprimer ce document ?",
      "deleteText": "{{name}} quitte toutes les générations de cette base. Les réponses déjà données gardent leurs citations."
    },
    "generations": {
      "retryFailed": "Réessayer les échecs",
      "refresh": "Rafraîchir les sources URL",
      "refreshing": "Les sources URL sont relues",
      "empty": "Aucune génération",
      "emptyText": "Une génération se construit dès que cette base tourne dans un environnement.",
      "digest": "Empreinte",
      "status": "Statut",
      "environments": "Servie dans",
      "waiting": "En attente",
      "created": "Créée",
      "liveSince": "En service depuis",
      "copyDigest": "Copier l'empreinte",
      "statuses": {
        "building": "En construction",
        "live": "En service",
        "retired": "Retirée",
        "failed": "Échec"
      }
    },
    "problems": {
      "document_too-large": "Le fichier dépasse 50 Mio, le maximum d'une base de connaissances.",
      "document_unsupported-type": "Ce type de fichier n'est pas lu ici : utilisez PDF, Word, texte, Markdown, HTML ou une image.",
      "document_deleting": "Ce document est en cours de suppression ; téléversez-le à nouveau une fois parti.",
      "document_not-found": "Ce document n'existe plus.",
      "storage_not-ready": "Le stockage des documents ne répond pas ; réessayez dans un instant.",
      "kb_not-found": "Cette base de connaissances n'existe pas."
    },
    "chunks_one": "{{count}} fragment",
    "chunks_other": "{{count}} fragments",
    "pages_one": "{{count}} page",
    "pages_other": "{{count}} pages"
  },
  "runs": {
    "nav": "Exécutions",
    "tab": "Exécutions",
    "title": "Exécutions",
    "description": "Exécutions des agents de {{project}}, les plus récentes d'abord.",
    "loading": "Chargement des exécutions…",
    "breadcrumb": "Fil d'Ariane",
    "openAll": "Voir toutes les exécutions de cet agent",
    "empty": {
      "title": "Aucune exécution",
      "text": "Les exécutions apparaissent ici dès qu'un agent de ce projet répond à une question."
    },
    "filters": {
      "agent": "Agent",
      "allAgents": "Tous les agents",
      "conversation": "Conversation {{id}}",
      "clear": "Retirer le filtre de conversation"
    },
    "columns": {
      "run": "Exécution",
      "agent": "Agent",
      "environment": "Environnement",
      "status": "Statut",
      "question": "Question",
      "created": "Créée",
      "duration": "Durée",
      "cost": "Coût"
    },
    "status": {
      "queued": "En file",
      "running": "En cours",
      "done": "Terminée",
      "failed": "Échec",
      "cancelled": "Annulée"
    },
    "stages": {
      "rewriting": "Reformulation de la question",
      "searching": "Recherche",
      "generating": "Rédaction"
    },
    "cached": "Depuis le cache",
    "cancel": "Annuler",
    "erase": "Effacer",
    "eraseTitle": "Effacer cette exécution ?",
    "eraseText": "L'exécution, sa réponse et sa copie en cache sont effacées définitivement.",
    "erased": "Exécution effacée",
    "created": "Créée",
    "started": "Démarrée",
    "finished": "Terminée",
    "tokens": "Jetons",
    "answer": "Réponse",
    "error": "Erreur",
    "warnings": "Avertissements",
    "passages": "Passages",
    "cited": "Citée",
    "page": "page {{page}}",
    "score": "score {{score}}",
    "textGone": "Texte plus disponible",
    "citation": "Source {{number}}",
    "stagesTitle": "Étapes",
    "reconnecting": "reconnexion",
    "streamLost": "Le suivi en direct de cette exécution est perdu",
    "streamRetry": "Suivre à nouveau",
    "usage": "Appels aux modèles",
    "call": "Appel",
    "tokensInOut": "Jetons entrée / sortie",
    "openChat": "Ouvrir la discussion"
  },
  "chat": {
    "nav": "Discussion",
    "command": "Poser une question à un agent",
    "title": "Discussion",
    "description": "Interrogez les agents rag de {{project}} déployés dans cet environnement.",
    "agent": "Agent",
    "chooseAgent": "Choisir un agent",
    "loadingAgents": "Chargement des agents…",
    "notRunnable": "{{name}} ({{type}} : pas encore disponible en discussion)",
    "noAgents": {
      "title": "Aucun agent ne tourne ici",
      "text": "Aucun agent de ce projet n'est déployé dans cet environnement.",
      "action": "Ouvrir les environnements"
    },
    "pick": {
      "title": "Choisir un agent",
      "text": "Choisissez un agent rag déployé pour lui poser une question."
    },
    "conversations": "Conversations",
    "conversation": "Conversation",
    "newConversation": "Nouvelle conversation",
    "loadingConversations": "Chargement des conversations…",
    "noConversations": "Aucune conversation pour l'instant.",
    "untitled": "Conversation sans titre",
    "eraseNamed": "Effacer la conversation {{title}}",
    "eraseTitle": "Effacer la conversation « {{title}} » ?",
    "eraseText": "Ses questions, réponses et exécutions sont effacées définitivement.",
    "erase": "Effacer la conversation",
    "erased": "Conversation effacée",
    "empty": {
      "title": "Poser une question",
      "text": "{{agent}} répond à partir de sa base de connaissances et cite ses sources."
    },
    "turns": "Questions et réponses",
    "you": "Vous :",
    "waiting": "En attente d'un worker",
    "stages": {
      "rewriting": "Reformulation de la question",
      "searching": "Recherche",
      "generating": "Rédaction"
    },
    "question": "Question",
    "placeholder": "Poser une question (Entrée envoie, Maj+Entrée passe à la ligne)",
    "counter": "{{count}} / {{max}}",
    "send": "Envoyer",
    "stop": "Arrêter",
    "stopped": "Arrêtée",
    "askAgain": "Reposer la question",
    "cached": "Depuis le cache",
    "tokens": "{{tokens}} jetons",
    "runDetails": "Détails de l'exécution",
    "showSources": "Afficher les sources",
    "sources": "Sources",
    "otherPassages": "Autres passages trouvés",
    "noSources": "Les sources de la réponse choisie s'affichent ici.",
    "noCitations": "La réponse ne cite aucun passage.",
    "refusals": {
      "agent": {
        "not-deployed": "Cet agent ne tourne pas dans {{environment}}.",
        "unsupported-type": "Le type de cet agent ne répond pas encore en discussion."
      },
      "kb": {
        "not-ready": "Sa base de connaissances n'a pas encore d'index prêt dans {{environment}}."
      },
      "conversation": {
        "mismatch": "Cette conversation appartient à un autre agent ou environnement."
      },
      "run": {
        "question-too-long": "La question est trop longue.",
        "input-invalid": "La question n'est pas valide."
      },
      "queue": {
        "not-ready": "Aucun worker ne traite les exécutions pour l'instant."
      }
    }
  }
}
